module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_fountain_pen_dc96922705bd691d5ca26549384cc63d.png";